export const useLocalSettings = defineStore('settings', {
  state: () => ({
    theme: null as 'light'|'dark'|null,
  }),
  persist: {
    storage: localStorage,
  }
});
